﻿/*
 * Globalize Culture fi-FI
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("fi-FI", "default", {
    name: "fi-FI",
    englishName: "Finnish (Finland)",
    nativeName: "suomi (Suomi)",
    language: "fi",
    numberFormat: {
      ",": " ",
      ".": ",",
      negativeInfinity: "-INF",
      positiveInfinity: "INF",
      percent: {
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": " ",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "sunnuntai",
            "maanantai",
            "tiistai",
            "keskiviikko",
            "torstai",
            "perjantai",
            "lauantai"
          ],
          namesAbbr: ["su", "ma", "ti", "ke", "to", "pe", "la"],
          namesShort: ["su", "ma", "ti", "ke", "to", "pe", "la"]
        },
        months: {
          names: [
            "tammikuu",
            "helmikuu",
            "maaliskuu",
            "huhtikuu",
            "toukokuu",
            "kesäkuu",
            "heinäkuu",
            "elokuu",
            "syyskuu",
            "lokakuu",
            "marraskuu",
            "joulukuu",
            ""
          ],
          namesAbbr: [
            "tammi",
            "helmi",
            "maalis",
            "huhti",
            "touko",
            "kesä",
            "heinä",
            "elo",
            "syys",
            "loka",
            "marras",
            "joulu",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "d.M.yyyy",
          D: "d. MMMM'ta 'yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d. MMMM'ta 'yyyy H:mm",
          F: "d. MMMM'ta 'yyyy H:mm:ss",
          M: "d. MMMM'ta'",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Lisäohjeita",
      AddNewTab: "Lisää uusi välilehti",
      Alerts: "Hälytykset",
      ApplyFilter: "Käytä suodatinta",
      Approve: "Hyväksy",
      Attachments: "Liitteet",
      Back: "Takaisin",
      Basic: "Perus",
      Between: "Välillä",
      Book: "Kirja",
      Cancel: "Peruuta",
      Checked: "Valittu",
      ClearFilter: "Tyhjennä suodatin",
      Close: "Sulje",
      CloseCancelChanges: "Sulje ja peruuta muutokset",
      CloseSaveChanges: "Sulje ja tallenna muutokset",
      CloseTab: "Sulje välilehti",
      ColumnPersonalization: "Sarakkeen mukautus",
      Comments: "Kommentit",
      Confirmation: "Vahvistus",
      Contains: "Sisältää",
      CreateTab: "Luo uusi välilehti",
      Cut: "Leikkaa",
      Delete: "Poista",
      DiscardUndo: "Hylkää/kumoa",
      DisplayDropDownList: "Näytä avattava luettelo",
      Displaying: "Näytetään: ",
      DocWord: "Asiakirja",
      DoesNotContain: "Ei sisällä",
      DoesNotEndWith: "Ei pääty merkkijonoon",
      DoesNotEqual: "Ei ole yhtä suuri kuin",
      DoesNotStartWith: "Ei ala merkkijonolla",
      Download: "Lataa",
      Duplicate: "Kaksoiskappale",
      Edit: "Muokkaa",
      EitherSelectedorNotSelected: "Joko valittu tai ei valittu",
      Email: "Sähköposti",
      EndsWith: "Päättyy merkkijonoon",
      EqualsStr: "Yhtä suuri kuin",
      ExpandCollapse: "Laajenna/pienennä",
      ExportFailed: "Vienti epäonnistui",
      ExportToExcel: "Vie Exceliin",
      FileInUse: "Määritetty tiedosto on käytössä",
      FileInUseDetail:
        "Sulje tiedosto sovelluksesta, jossa se on käytössä, tai määritä eri tiedostonimi.",
      Filter: "Suodata",
      FilterMenu: "Suodata-valikko",
      FilterOptions: "Suodatusasetukset",
      FilterWithinResults: "Suodata tuloksista",
      First: "Ensimmäinen",
      FirstView: "Ensimmäinen näkymä",
      Folder: "Kansio",
      ForgotPassword: "Unohditko salasanasi?",
      Forward: "Eteenpäin",
      GetMoreRows: "Hae lisää rivejä",
      GreaterThan: "Suurempi kuin",
      GreaterThanOrEquals: "Suurempi tai yhtä suuri kuin",
      GridSettings: "Ruudukon asetukset",
      GroupSelection: "Ryhmän valinta",
      Help: "Ohje",
      HideColumn: "Piilota sarake",
      IsEmpty: "On tyhjä",
      IsNotEmpty: "Ei ole tyhjä",
      Last: "Viimeinen",
      LastView: "Viimeinen näkymä",
      LaunchActivate: "Käynnistä/aktivoi",
      LessThan: "Pienempi kuin",
      LessThanOrEquals: "Pienempi tai yhtä suuri kuin",
      Links: "Linkit",
      ListTabs: "Luettele kaikki välilehdet",
      LoadingItem: "Ladataan kohdetta ",
      Maintenance: "Ylläpito",
      Menu: "Valikko",
      New: "Uusi",
      Next: "Seuraava",
      NextView: "Seuraava näkymä",
      No: "Ei",
      NotChecked: "Ei tarkistettu",
      Notes: "Huomautukset",
      NotSelected: "Ei valittu",
      Of: " / ",
      Ok: "OK",
      Open: "Avaa",
      Password: "Salasana",
      Paste: "Liitä",
      Phone: "Puhelin",
      PleaseWait: "Odota",
      Previous: "Edellinen",
      PreviousView: "Edellinen näkymä",
      Print: "Tulosta",
      Queries: "Kyselyt",
      Redo: "Toista",
      Refresh: "Päivitä",
      Reject: "Hylkää",
      RememberMe: "Muista minut tällä tietokoneella",
      Reports: "Raportit",
      Reset: "Nollaa",
      Review: "Tarkista",
      RunFilter: "Suorita suodatin",
      RunJob: "Suorita työ",
      Save: "Tallenna",
      SaveBeforeClosing: "Tallenna ennen sulkemista",
      SavedFilters: "Tallennetut suodattimet",
      SaveSubmit: "Tallenna/lähetä",
      ScreenDesign: "Näytön rakenne",
      Search: "Haku",
      SelectContents: "Valitse sisältö",
      SelectDate: "Valitse päivämäärä",
      SelectDeselect: "Valitse / poista kaikkien valinta",
      Selected: "Valittu: ",
      ServerName: "Palvelimen nimi",
      Settings: "Asetukset",
      ShowFilterRow: "Näytä suodatinrivi",
      SignIn: "Kirjaudu sisään",
      SortAscending: "Lajittele nousevassa järjestyksessä",
      SortDescending: "Lajittele laskevassa järjestyksessä",
      Spreadsheet: "Laskentataulukko",
      StartsWith: "Alkaa merkkijonolla",
      StatusIndicator: "Tilan ilmaisin",
      Tasks: "Tehtävät",
      Today: "Tänään",
      Translate: "Käännä",
      UserID: "Käyttäjätunnus",
      Utilities: "Apuohjelmat",
      Yes: "Kyllä",
      Page: "Sivu",
      Rows: "Rivit",
      ShowingAll: "Näytetään kaikki",
      SessionNavigation: "Istunnon navigointi",
      ListAllMenuItems: "Luettelo kaikki valikkokohteet",
      NoRecordsFound: "Tietueita ei löytynyt",
      SearchTree: "Hae puusta",
      Clear: "Tyhjennä",
      DrillDown: "Poraudu",
      Required: "Tämä kenttä on pakollinen",
      Available: "Käytettävissä:",
      Add: "Lisää",
      MoveDown: "Siirry alaspäin",
      MoveUp: "Siirry ylöspäin",
      Remove: "Poista",
      LastYear: "Viime vuosi",
      NextMonth: "Seuraava kuukausi",
      NextWeek: "Seuraava viikko",
      NextYear: "Seuraava vuosi",
      OneMonthAgo: "Kuukausi sitten",
      OneWeekAgo: "Viikko sitten",
      SixMonthsAgo: "Kuusi kuukautta sitten",
      Time: "Aika",
      CannotBeSelected: "Tätä riviä ei voi valita.",
      ResetToDefault: "Palauta oletusasettelu",
      CloseOtherTabs: "Sulje muut välilehdet",
      EmailValidation: "Anna kelvollinen sähköpostiosoite",
      UrlValidation: "Anna kelvollinen URL-osoite",
      EndofResults: "Tulosten loppu",
      More: "Lisää...",
      RecordsPerPage: "Tietueita sivulla",
      Maximize: "Maksimoida",
      Minimize: "Minimoida"
    }
  });
})(this);
